<template>
  <div class="mt-4">
    <template v-if="item.link">
      <jump-start-video
        :key="'video' + item.link"
        :video="item"
      ></jump-start-video>
    </template>

    <v-expansion-panels popout v-else>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="title">{{ item.title }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="item.items && item.items.length > 0">
            <jump-start-item
              v-for="subfolder in item.items"
              :item="subfolder"
              :key="subfolder.title"
            ></jump-start-item>
          </template>

          <p v-else>Folder is empty</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import JumpStartVideo from './Video.vue';

export default {
  name: 'JumpStartItem',
  components: { JumpStartVideo },
  props: ['item'],
}
</script>

<style>

.title {
  color: #40ae75;
  font-size: 2.125rem;
  line-height: 2.5rem;
}
</style>